import { render, staticRenderFns } from "./Report2024.vue?vue&type=template&id=994cbebe&scoped=true&"
import script from "./Report2024.vue?vue&type=script&lang=js&"
export * from "./Report2024.vue?vue&type=script&lang=js&"
import style0 from "./Report2024.vue?vue&type=style&index=0&id=994cbebe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "994cbebe",
  null
  
)

export default component.exports